<template>
  <div>
    <home-carousel />
    <!-- 彈窗廣告 -->
    <div
      v-if="popupVisible && currentDetail"
      class="popup-wrap promo-popup"
      :class="{ active:popupVisible && currentDetail}"
    >
      <div class="popup-box">
        <div class="promo-popup-inner">
          <picture>
            <img :src="currentDetail.image_small" alt="">
          </picture>
          <ul class="promo-popup-title">
            <li>
              <h4>{{ currentDetail.name }}</h4>
            </li>
          </ul>
          <div class="promo-detail">
            <!-- eslint-disable-next-line -->
            <span v-html="getContent(activeId)" />
          </div>
          <div class="popup-footer justify-content-center">
            <button
              v-if="currentDetail.type !== 'pure'"
              class="btn btn-secondary flex-fill goTo-promo-popup"
              :class="{ 'redeemed': currentDetail.status === 2, 'coming-soon': currentDetail.status === 4 }"
              :disabled="actionLoading"
              @click.stop="clickAction(currentDetail)"
            >
              {{ user.language === "jp" ? (currentDetail.status === 4 ? '開催中' : (currentDetail.status === 1 ? '未開催' : currentDetail.status_text)) : currentDetail.status_text }}
            </button>
          </div>
        </div>
        <a class="popup-close" @click.prevent="hidePopup"><i class="fa-solid fa-xmark" /></a>
      </div>
    </div>
    <div class="main-max-width">
      <!-- 最新優惠 -->
      <div class="promo-wrap">
        <!-- 最新優惠-列表 -->
        <div ref="movetoHere" class="promo-list">
          <div
            v-for="(item, key) in promoEvents"
            :key="key"
            :ref="'promoCard-' + item.id"
            class="promo-card"
            :class="{ 'active': activeId === item.id }"
          >
            <div class="promo-card-image" @click="togglePromoDetail(item.id)">
              <picture>
                <img :src="item.image_mobile" :alt="item.name">
              </picture>
            </div>
            <ul class="promo-info" @click="togglePromoDetail(item.id)">
              <li>{{ item.name }}</li>
              <li v-if="false">
                {{ $t("Bao.event_period") }}:{{ item.start_at | dateFormat }}~{{ item.end_at | dateFormat }}
              </li>
              <li v-else />
              <li :class="{ 'active': activeId === item.id }">
                <div class="promo-detail-toggle fs-1">
                  <i class="fa-solid fa-angle-down" />
                </div>
                <div class="promo-detail" :class="{ 'active': activeId === item.id }">
                  <!-- eslint-disable-next-line -->
                  <div v-html="getContent(item.id)" />
                </div>
              </li>
              <li v-if="item.showButton">
                <div class="popup-footer justify-content-center">
                  <button
                    :key="item.id"
                    class="btn btn-secondary flex-fill goTo-promo-popup"
                    :class="{ 'redeemed': item.status === 2,
                              'coming-soon': item.status === 4 || item.status === 1}"
                    :disabled="actionLoading"
                    @click.stop="clickAction(item)"
                  >
                    {{ user.language === "jp" ? (item.status === 4 ? '開催中' : (item.status === 1 ? '未開催' : item.status_text)) : item.status_text }}
                  </button>
                </div>
              </li>
            </ul>
          </div>
        </div>
        <div v-show="enableAutoLoad" class="promo-more">
          <button class="button-style-6">
            <span>Load more</span>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getEvent, getEventDetail, joinEvent, receive, getEventQualification } from '@/api/event'
import { showNotice, detectMob } from '@/utils/tool'
import homeCarousel from '@/components/homeCarousel'

export default {
  name: 'Event',
  components: {
    homeCarousel
  },
  data() {
    return {
      actionLoading: false,
      list: [],
      page: 1,
      pageSize: 50,
      enableAutoLoad: false,
      popupVisible: false,
      detail: {},
      activeId: null,
      savedScrollPosition: null
    }
  },
  metaInfo() {
    return {
      title: this.$store.state.app.metaInfo.title,
      meta: [
        {
          vmid: 'events',
          name: 'keywords',
          content: this.$store.state.app.metaInfo.keywords
        }, {
          name: 'description',
          content: this.$store.state.app.metaInfo.description
        }
      ]
    }
  },
  beforeRouteEnter(to, from, next) {
    const id = to.query.eventId
    const shareCode = to.query.share_code

    next(vm => {
      if (shareCode) {
        vm.handleShareCode(shareCode)
      }
      if (id && vm.list.some(item => item.id === id)) {
        vm.showPopup(id)
      }
    })
  },
  computed: {
    user() {
      return this.$store.state.user
    },
    currentDetail() {
      if (Array.isArray(this.detail[this.activeId])) {
        showNotice(this.$t('Bao.event_end'))
        return false
      }
      return this.detail[this.activeId] || {}
    },
    depositPromotion() {
      if (this.$store.getters.token) {
        const { first_deposit_at, second_deposit_at, third_deposit_at } = this.user.memberInfo
        const daily_multiple_deposit = this.list.some(element => element.type === 'daily_multiple_deposit')

        if (!first_deposit_at) {
          return this.list.find(item => item.type === 'manual_first_deposit')
        } else if (!second_deposit_at) {
          return this.list.find(item => item.type === 'manual_second_deposit')
        } else if (!third_deposit_at) {
          return this.list.find(item => item.type === 'manual_third_deposit')
        } else if (third_deposit_at && !daily_multiple_deposit) {
          return this.list.find(item => item.type === 'manual_first_deposit')
        } else {
          return this.list.find(item => item.type === 'daily_multiple_deposit')
        }
      } else {
        return this.list
      }
    },
    promoEvents() {
      const depositPromo = this.depositPromotion
      const depositTypes = ['manual_first_deposit', 'manual_second_deposit', 'manual_third_deposit', 'daily_multiple_deposit']

      const filteredList = this.list.filter(item => {
        // Include the item if it's not a deposit type or if it's the depositPromotion
        return (!depositTypes.includes(item.type) || (depositPromo && item.id === depositPromo.id))
      })

      // Add showButton property to each item
      return filteredList.map(item => ({ ...item, showButton: item.type !== 'pure' && item.type !== 'bet_ranking' && item.type !== 'bet_ranking_by_type' }))
    }
  },
  watch: {
    list(newList) {
      if (newList.length > 0) {
        const id = this.$route.query.eventId
        if (id) {
          this.togglePromoDetail(id)
          this.$router.replace({ path: this.$route.path })
        }
      }
    },
    'user.isLoginToEvent'() {
      this.slideHere()
    }
  },
  async created() {
    this.oneQuery()
  },
  methods: {
    handleShareCode(shareCode) {
      this.$store.commit('SET_SHARE_CODE', shareCode)
      localStorage.setItem('shareCode', shareCode)
    },
    async query() {
      const queryObj = {
        'page': this.page,
        'page_size': this.pageSize
      }

      const res = await getEvent(queryObj)
      this.list = res.data.data.list.filter(item => item.is_show === 1)
      if (res.data.data.list.length < this.pageSize) {
        this.enableAutoLoad = false
      } else {
        this.enableAutoLoad = true
        this.page += 1
      }
      this.slideHere()
    },
    oneQuery() {
      this.page = 1
      this.query()
    },
    togglePromoDetail(id) {
      const numId = Number(id)
      if (this.list.map(value => value.id).includes(numId)) {
        if (this.activeId === numId) {
          // When closing, scroll back to the remembered position
          if (this.savedScrollPosition) {
            window.scrollTo({ top: this.savedScrollPosition, behavior: 'smooth' })
          }
          this.activeId = null
          this.popupVisible = false
        } else {
          // When opening, remember the current scroll position
          this.savedScrollPosition = window.scrollY

          this.activeId = numId
          getEventDetail(numId).then(response => {
            this.$set(this.detail, numId, response.data.data)
            this.$nextTick(() => {
              const activeCard = this.$refs['promoCard-' + id][0]
              if (activeCard && detectMob()) {
                const offset = 50
                const top = activeCard.getBoundingClientRect().top + window.scrollY - offset
                window.scrollTo({ top, behavior: 'smooth' })
              }
            })
            this.popupVisible = true
          }).catch((error) => {
            showNotice(error.response.data.msg)
          })
        }
      }
    },
    slideHere() {
      if (this.user.isLoginToEvent) {
        const offset = detectMob() ? 50 : 0
        const top = this.$refs.movetoHere.getBoundingClientRect().top + window.scrollY - offset
        window.scrollTo({ top, behavior: 'smooth' })
      }
      this.$store.commit('SET_LOGIN_TO_EVENT', false)
    },
    getContent(id) {
      return this.detail[id] ? this.detail[id].content : ''
    },
    showPopup(eventId) {
      getEventDetail(eventId).then(response => {
        this.activeId = eventId
        this.$set(this.detail, eventId, response.data.data)
        this.popupVisible = true
      }).catch((error) => {
        showNotice(error.response.data.msg)
      })
    },
    hidePopup() {
      this.activeId = null
      this.popupVisible = false
    },
    async clickAction(item) {
      if (this.actionLoading) {
        return
      }

      this.actionLoading = item.id

      try {
        let response
        switch (item.status) {
          case 0:
            this.$store.commit('SET_LOGIN_OPEN', true)
            this.popupVisible = false
            break
          case 3:
            response = await getEventQualification(item.type)
            this.handleEventQualificationResponse(response.data.data.code, item.id)
            break
          case 5:
            response = await receive(item.event_member_id)
            showNotice(response.data.msg)
            this.query()
            break
        }
      } catch (error) {
        showNotice(error.response.data.msg)
      } finally {
        this.actionLoading = false
      }
    },
    handleEventQualificationResponse(code, eventId) {
      const messageMap = {
        1001: this.$t('Bao.special_deposit_err6'),
        2001: this.$t('Bao.unavailible_3') + code + this.$t('Bao.unavailable_2'),
        3001: this.$t('Bao.unavailible_3') + code + this.$t('Bao.unavailable_2'),
        2101: this.$t('Bao.member_type_not_pass'),
        5101: this.$t('Bao.first_deposit_exist'),
        5102: this.$t('Bao.first_deposit_not_enough'),
        5201: this.$t('Bao.second_deposit_exist'),
        5202: this.$t('Bao.second_deposit_not_enough'),
        5301: this.$t('Bao.third_deposit_exist'),
        5302: this.$t('Bao.third_deposit_not_exist')
      }

      if (messageMap[code]) {
        showNotice(messageMap[code])
      } else {
        this.joinEventAndHandleResponse(eventId)
      }
    },
    async joinEventAndHandleResponse(eventId) {
      try {
        const response = await joinEvent(eventId)
        showNotice(response.data.msg)
        this.query()
      } catch (error) {
        showNotice(error.response.data.msg)
      }
    }
  }
}
</script>
